<template>
  <page-header />
  <a-layout class="profile-container">
    <a-layout-content>
      <a-card title="个人中心" class="profile-card">
        <a-list bordered>
          <a-list-item>
            <a-button type="link" @click="toOrderPage()">我的订单</a-button>
          </a-list-item>
          <template #header>
            <div>我的菜单</div>
          </template>
<!--          <template #footer>-->
<!--            <div>Footer</div>-->
<!--          </template>-->
        </a-list>
        <!-- 加载状态 -->
        <a-spin :spinning="loading">
          <!-- 个人信息展示区域 -->
          <div class="info-section">
            <a-descriptions title="基本信息" :column="1" bordered>
              <template v-for="item in profileItems">
                <a-descriptions-item
                    v-if="item.view_rule === 'public' || item.view_rule === 'private'"
                    :key="item.key"
                    :label="item.name"
                    style="position: relative;"
                >
                  <template v-if="item.key === 'avatar'">
                    <a-avatar :src="userInfo[item.key]" :size="64" />
                  </template>
                  <template v-else>
                    <template v-if="item.modify_rule === 'self'">
                      {{ userInfo[item.key] || '未设置' }}
                    </template>
                    <template v-else>
                      {{ userInfo[item.key] }}
                    </template>
                  </template>

                  <!-- 添加编辑按钮 -->
                  <a-button
                      v-if="item.modify_rule === 'self'"
                      type="link"
                      size="small"
                      @click="showEditModal(item)"
                      style="position: absolute;right: 0;bottom: 0;"
                  >
                    修改
                  </a-button>
                </a-descriptions-item>
              </template>
            </a-descriptions>
          </div>
        </a-spin>
      </a-card>
    </a-layout-content>

    <!-- 普通字段编辑弹窗 -->
    <a-modal
        v-model:open="editModal.visible"
        :title="`修改${editModal.currentItem?.name}`"
        @ok="handleEditSubmit"
        @cancel="handleEditCancel"
        v-if="editModal.currentItem?.key !== 'avatar'"
    >
      <a-form :model="editModal.formState" layout="vertical">
        <a-form-item :label="editModal.currentItem?.name">
          <a-input v-model:value="editModal.formState.value" />
        </a-form-item>
      </a-form>
    </a-modal>

    <!-- 头像上传弹窗 -->
    <a-modal
        v-model:open="avatarModal.visible"
        title="修改头像"
        @ok="handleAvatarSubmit"
        @cancel="avatarModal.visible = false"
        v-if="editModal.currentItem?.key === 'avatar'"
    >
      <a-upload
          v-model:file-list="avatarModal.fileList"
          name="avatar"
          list-type="picture-card"
          class="avatar-uploader"
          :show-upload-list="false"
          :before-upload="beforeAvatarUpload"
          @change="handleAvatarChange"
      >
        <img v-if="avatarModal.imageUrl" :src="avatarModal.imageUrl" alt="avatar" style="width: 100%"/>
        <div v-else>
          <a-icon :type="avatarModal.loading ? 'loading' : 'plus'" />
          <div class="ant-upload-text">上传头像</div>
        </div>
      </a-upload>
    </a-modal>
  </a-layout>
</template>

<script>
import { defineComponent, ref, reactive, onMounted } from 'vue'
import { message } from 'ant-design-vue'
import request from '@/utils/request'
import PageHeader from "@/components/header.vue";
import {useRouter} from "vue-router";

export default defineComponent({
  components: {PageHeader},
  setup() {
    // 加载状态
    const loading = ref(true)
    // 用户信息数据
    const userInfo = ref({})
    // 个人资料配置项
    const profileItems = ref([])

    // 编辑弹窗状态
    const editModal = reactive({
      visible: false,
      currentItem: null,
      formState: {
        key: '',
        value: ''
      }
    })

    // 头像上传状态
    const avatarModal = reactive({
      visible: false,
      loading: false,
      fileList: [],
      imageUrl: ''
    })

    // 获取个人信息接口
    const fetchUserInfo = async () => {
      try {
        const response = await request.get('/user/my_profile')
        userInfo.value = response.data
      } catch (error) {
        message.error('获取个人信息失败')
        console.error(error)
      }
    }

    // 获取资料配置项接口
    const fetchProfileScene = async () => {
      try {
        const response = await request.get('/site/scene/profile')
        profileItems.value = response.data.profile_items || []
      } catch (error) {
        message.error('获取资料配置失败')
        console.error(error)
      } finally {
        loading.value = false
      }
    }

    // 显示编辑弹窗
    const showEditModal = (item) => {
      editModal.currentItem = item
      if (item.key === 'avatar') {
        // 头像特殊处理
        avatarModal.visible = true
        avatarModal.imageUrl = userInfo.value.avatar || ''
      } else {
        // 普通字段处理
        editModal.formState = {
          key: item.key,
          value: userInfo.value[item.key] || ''
        }
        editModal.visible = true
      }
    }

    // 头像上传前校验
    const beforeAvatarUpload = (file) => {
      const isImage = file.type.startsWith('image/')
      if (!isImage) {
        message.error('只能上传图片文件!')
      }
      const isLt2M = file.size / 1024 / 1024 < 2
      if (!isLt2M) {
        message.error('图片大小不能超过2MB!')
      }
      if (isImage && isLt2M) {
        avatarModal.fileList = [file];
      }
      return false
    }

    // 头像上传状态变化
    const handleAvatarChange = (info) => {
      if (info.file.status === 'uploading') {
        avatarModal.loading = true
        return
      }
      if (info.file.status === 'done') {
        avatarModal.imageUrl = URL.createObjectURL(info.file.originFileObj)
        avatarModal.loading = false
      }
    }

    // 提交头像修改
    const handleAvatarSubmit = async () => {
      if (!avatarModal.fileList.length) {
        message.warning('请先选择头像图片')
        return
      }

      try {
        const formData = new FormData()
        formData.append('file', avatarModal.fileList[0].originFileObj)
        formData.append('scene', 'user');

        const res = await request.post('/user/renew_avatar', formData, {
          headers: {
            'Content-Type': 'multipart/form-data'
          }
        })
        if (res.code !== 'success') {
          message.error(res.msg)
          return
        }

        message.success('头像修改成功')
        await fetchUserInfo()
        avatarModal.visible = false
      } catch (error) {
        message.error(error.response?.data?.message || '头像修改失败')
        console.error(error)
      }
    }

    // 提交修改
    const handleEditSubmit = async () => {
      try {
        const res = await request.post('/user/renew', {
          [editModal.formState.key]: editModal.formState.value
        })
        if (res.code !== 'success') {
          let msg = '修改失败'
          for (const key in res.data) {
            msg = res.data[key]
            break
          }
          message.error(msg)
          return
        }
        message.success('修改成功')
        // 刷新数据
        await fetchUserInfo()
        editModal.visible = false
      } catch (error) {
        message.error(error.response?.data?.message || '修改失败')
        console.error(error)
      }
    }

    // 取消编辑
    const handleEditCancel = () => {
      editModal.visible = false
    }

    const router = useRouter();
    const toOrderPage = () => {
      router.push({ path: '/user/order/page' });
    }

    // 组件挂载时获取数据
    onMounted(async () => {
      await Promise.all([
        fetchUserInfo(),
        fetchProfileScene()
      ])
    })

    return {
      loading,
      userInfo,
      profileItems,
      editModal,
      avatarModal,
      showEditModal,
      handleEditSubmit,
      handleEditCancel,
      handleAvatarSubmit,
      beforeAvatarUpload,
      handleAvatarChange,
      toOrderPage
    }
  }
})
</script>

<style scoped>
/* 页面容器样式 */
.profile-container {
  min-height: 100vh;
  padding: 20px;
  background: #f0f2f5;
}

/* 卡片样式 */
.profile-card {
  max-width: 800px;
  margin: 0 auto;
}

/* 信息区域样式 */
.info-section {
  margin-bottom: 24px;
}

/* 头像区域样式 */
.avatar-section {
  text-align: center;
  margin-bottom: 20px;
}

/* 头像上传组件样式 */
.avatar-uploader >>> .ant-upload {
  width: 128px;
  height: 128px;
}
</style>
